<template>
    <div class="col-12 text-left">
        <h3 class="p-2">
            <small class="text-muted">Harga Produk Detail</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <app-lookup-field :model="productPrice" :element="productLookup" v-on:selectLookup="finishLookup"></app-lookup-field>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <label for="price-input">Harga</label>
                <input type="number" class="form-control" v-model="productPrice.price" id="price-input" aria-describedby="name" placeholder="Harga Produk">
            </div>
        </div>
        <button type="button" class="btn btn-outline-success" @click="save">Save <i class="far fa-save"></i></button>
        <button type="button" class="btn btn-outline-danger" @click="cancel">Cancel <i class="far fa-window-close"></i></button>
    </div>
</template>

<script>
import api from '../../../services/api'
import { ProductPrice } from '../../../models/productPrice'
import AppLookupField from '../../../components/AppLookupField.vue'

export default {
    components: {
        AppLookupField
    },
    data() {
        return {
            productPrice: {
                ...ProductPrice
            },
            productLookup: {
                id: 'product',
                title: 'Produk',
                type: 'form',
                apiUrl: 'product',
                filter: ['code', 'name'],
                fields: [
                    {
                        placeholder: 'Nama Produk',
                        width: 6,
                        column: 'productName'
                    }
                ],
                dtElements: [
                    {
                        title: 'Code',
                        column: 'code'
                    },
                    {
                        title: 'Merk',
                        column: 'brand'
                    },
                    {
                        title: 'Name',
                        column: 'name'
                    },
                ],
                affectedField: [
                    {
                        from: 'id',
                        to: 'productId'
                    },
                    {
                        from: 'code',
                        to: 'productCode'
                    },
                    {
                        from: 'name',
                        to: 'productName'
                    }
                ]
            }
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const productPriceApi = api('product-price')
            this.productPrice = await productPriceApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        async save() {
            const productPriceApi = api('product-price')
            if(this.$route.query.id !== undefined) {
                await productPriceApi.update(this.productPrice, this.$route.query.id)
            } else {
                await productPriceApi.create(this.productPrice)
            }
            this.$router.go(-1)
        },
        cancel() {
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentProductPrice = this.productPrice
            this.productPrice = {
                ...currentProductPrice,
                ...data
            }
        }
    }
}
</script>
